export default {
  ad: {
    id: 'swap_ad',
    defaultMessage:
      'Your {title}, from {price}*, with the buyback of your old device.',
  },
  purposal: {
    id: 'swap_buyback_intro_journey_purposal',
    defaultMessage: 'Have you got a device to sell?',
  },
  yes: {
    id: 'swap_buyback_purposal_yes',
    defaultMessage: 'Yes',
  },
  yesSubtitle: {
    id: 'swap_buyback_purposal_yes_subtitle',
    defaultMessage: 'Estimate the buyback offer >',
  },
  no: {
    id: 'swap_buyback_purposal_no',
    defaultMessage: 'No',
  },
}
